import styled from 'styled-components';

export const SidebySide = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  grid-template-areas:
    'courses summary'
    'recommended recommended';
  column-gap: clamp(var(--space-xl), 4vw, var(--space-xxxl));
  row-gap: var(--space-xxl);

  align-items: start;

  width: 100%;
  margin-block: var(--space-xl) var(--space-xxxl);

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'courses'
      'summary'
      'recommended';

    gap: var(--space-xl);

    margin-block: var(--space-l) var(--space-xxl);
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-l);

    margin-block: var(--space-m) var(--space-xl);
  }
`;

export const CourseInfoTable = styled.section`
  grid-area: courses;

  display: flex;
  flex-direction: column;

  min-width: 0;
  width: 100%;
`;

export const CartItemsList = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-s);

  width: 100%;

  margin-top: var(--space-l);

  @media screen and (max-width: 600px) {
    margin-top: var(--space-m);
    gap: var(--space-xs);
  }
`;

export const CheckoutSummaryPanel = styled.aside`
  grid-area: summary;

  position: sticky;
  top: calc(92px + var(--space-m));

  width: 100%;

  padding: var(--space-l);

  background: linear-gradient(
    145deg,
    rgba(255, 240, 194, 0.4) 0%,
    rgba(254, 254, 254, 0.98) 38%,
    var(--white) 100%
  );

  border: 1px solid var(--grey1);
  border-top: 3px solid var(--yellow4);

  border-radius: var(--borderRadiusLarge);

  box-shadow: var(--shadow-md);

  @media screen and (max-width: 900px) {
    position: static;

    max-width: 100%;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-m);

    border-radius: var(--borderRadius);
  }
`;

export const RecommendedCoursesArea = styled.div`
  grid-area: recommended;

  width: 100%;

  margin-top: var(--space-m);

  @media screen and (max-width: 600px) {
    margin-top: 0;
  }
`;

export const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--space-s);
  /* border: 2px solid red; */
  width: 100%;
  margin-top: var(--space-l);

  .checkoutButton {
    min-width: 100%;
    max-width: 100%;
    min-height: 48px;
  }

  @media screen and (max-width: 900px) {
    align-items: flex-start;

    .checkoutButton {
      width: auto;
      min-width: 280px;
      max-width: 100%;
    }
  }

  @media screen and (max-width: 500px) {
    .checkoutButton {
      width: 100%;
      min-width: 0;
    }
  }
`;

export const SecureNote = styled.p`
  margin: var(--space-xs) 0 0;

  color: var(--grey4);

  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.4;

  text-align: center;

  &::before {
    content: '✓';

    margin-right: 0.35rem;

    color: var(--successGreen);

    font-weight: 800;
  }
`;

export const CheckoutError = styled.p`
  margin: 0;
  padding: var(--space-s);

  color: var(--errorRed);

  background: var(--lightRed);

  border-radius: var(--borderRadiusSmall);

  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.4;

  text-align: center;
`;

export const TransactionMain = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 100vh;
  width: 100%;

  padding: var(--space-l);

  background: radial-gradient(
      circle at top left,
      rgba(255, 214, 107, 0.22),
      transparent 28%
    ),
    var(--grey15);

  @media screen and (max-width: 768px) {
    padding: var(--space-m);
  }
`;

export const TransactionCompleteSection = styled.section`
  width: min(100%, 600px);

  padding: var(--space-xl);

  background: var(--white);

  border: 1px solid var(--grey1);
  border-top: 4px solid var(--yellow4);
  border-radius: var(--borderRadiusLarge);

  box-shadow: var(--shadow-md);

  h2,
  h4 {
    margin-bottom: var(--space-s);

    font-weight: 700;
  }

  h4 {
    color: var(--grey3);

    font-weight: 500;
  }

  p {
    margin-bottom: var(--space-s);

    color: var(--grey4);

    font-size: var(--space-m);
    line-height: 1.6;
  }

  ul {
    margin: 0;
    padding: 0;

    li {
      margin-block: var(--space-xs);

      color: var(--grey4);

      list-style: none;
    }
  }

  button {
    width: 100%;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;
export const DeleteCartItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  padding: 0;

  @media screen and (max-width: 600px) {
    align-self: flex-start;
  }
`;

export const DeleteCartButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  padding: 0;

  color: var(--grey4);

  background: var(--white);

  border: 1px solid var(--grey1);
  border-radius: 50%;

  box-shadow: var(--shadow-xs);

  cursor: pointer;

  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: var(--errorRed);

    background: var(--lightRed);

    border-color: rgba(208, 17, 36, 0.18);

    transform: translateY(-1px);

    box-shadow: var(--shadow-sm);
  }

  &:focus-visible {
    outline: 2px solid var(--errorRed);
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;

    opacity: 0.5;

    transform: none;
    box-shadow: none;
  }

  @media screen and (max-width: 600px) {
    width: 32px;
    height: 32px;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`;
